// src/pages/Institutional/ForProfessionals.js
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import {
  Container,
  Box,
  Typography,
  Paper,
  Grid,
  Divider,
  Button,
  Chip
} from '@mui/material'
import {
  BusinessCenter,
  TrendingUp,
  VerifiedUser,
  Speed,
  MoneyOff,
  Repeat,
  Dashboard,
  WhatsApp,
  Star,
  Groups,
  Assessment,
  CloudUpload,
  AddHome
} from '@mui/icons-material'
import bannerProfissionais from '../../assets/banner_corretores_e_imobiliarias.png'

const ForProfessionals = () => {
  const benefits = [
    {
      icon: <TrendingUp />,
      title: 'Visibilidade real',
      description:
        'Seu imóvel aparece de forma clara e organizada, com prioridade para anúncios bem apresentados e completos.'
    },
    {
      icon: <WhatsApp />,
      title: 'Leads diretos',
      description:
        'Os contatos chegam diretamente para você via WhatsApp, formulário do portal ou e-mail (opcional). Não intermediamos conversas e não cobramos comissão.'
    },
    {
      icon: <Repeat />,
      title: 'Anúncios ilimitados',
      description:
        'Você pode publicar quantos imóveis desejar. Ótimo para imobiliárias com grande portfólio.'
    },
    {
      icon: <Speed />,
      title: 'Plataforma rápida e organizada',
      description:
        'Filtros simples, interface moderna e experiência pensada para que o usuário encontre exatamente o que procura.'
    },
    {
      icon: <MoneyOff />,
      title: 'Sem anúncios duplicados',
      description: 'Nosso sistema reduz confusão e prioriza qualidade.'
    },
    {
      icon: <Star />,
      title: 'Curadoria e ranking inteligente',
      description:
        'Anúncios completos, com boas fotos e preço justo ganham destaque naturalmente.'
    },
    {
      icon: <VerifiedUser />,
      title: 'Validação de CRECI',
      description: 'Corretores têm selo que aumenta confiança e transparência.'
    }
  ]

  const exclusiveFeatures = [
    { icon: <Groups />, label: 'Cadastro de equipe' },
    { icon: <Dashboard />, label: 'Gerenciamento de imóveis' },
    { icon: <WhatsApp />, label: 'Leads separados por imóvel' },
    { icon: <Star />, label: 'Destaques opcionais' },
    {
      icon: <Assessment />,
      label: 'Organização por tipo, região e características'
    },
    { icon: <CloudUpload />, label: 'Planejamento para integração com CRM' },
    {
      icon: <Assessment />,
      label: 'Futuro painel avançado com dados de desempenho'
    },
    { icon: <VerifiedUser />, label: 'Validação de marca e perfil comercial' }
  ]

  const steps = [
    {
      number: '1',
      title: 'Crie sua conta como Imobiliária ou Corretor',
      description:
        'Incluindo nome, e-mail, telefone, CRECI (para corretores) e CNPJ e razão social (para imobiliárias).'
    },
    {
      number: '2',
      title: 'Publique seus imóveis',
      description:
        'Adicione fotos, descrição, preço, características, detalhes importantes e localização aproximada.'
    },
    {
      number: '3',
      title: 'Receba leads diretamente',
      description:
        'O portal envia mensagens via WhatsApp, formulários de contato e, quando habilitado, notificações por e-mail.'
    },
    {
      number: '4',
      title: 'Gerencie tudo no painel',
      description:
        'Edite anúncios, veja leads, controle dados e mantenha seu portfólio atualizado.'
    }
  ]

  const boostLevels = [
    {
      level: 'Destaque leve',
      description: 'Aumenta visibilidade moderadamente'
    },
    { level: 'Destaque médio', description: 'Maior prioridade nos resultados' },
    {
      level: 'Destaque premium',
      description: 'Máxima visibilidade e posicionamento'
    }
  ]

  const integrationFormats = ['XML', 'JSON', 'FTP/SFTP', 'API']

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', py: 6 }}>
      <Container maxWidth='lg'>
        {/* Banner CTA */}
        <Paper
          elevation={0}
          sx={{
            mb: 6,
            borderRadius: 4,
            overflow: 'hidden',
            border: '1px solid',
            borderColor: 'grey.200',
            position: 'relative',
            minHeight: { xs: 'auto', md: 360 }
          }}
        >
          {/* Imagem de fundo (mobile) */}
          <Box
            sx={{
              display: { xs: 'block', md: 'none' },
              position: 'absolute',
              top: 0,
              right: 0,
              width: '60%',
              height: '100%'
            }}
          >
            <Box
              component='img'
              src={bannerProfissionais}
              alt='Banner para corretores e imobiliárias'
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'right top'
              }}
            />
          </Box>

          {/* Gradiente para legibilidade no mobile */}
          <Box
            sx={{
              display: { xs: 'block', md: 'none' },
              position: 'absolute',
              top: 0,
              left: 0,
              width: '70%',
              height: '100%',
              background:
                'linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.95) 50%, rgba(255,255,255,0) 100%)',
              pointerEvents: 'none',
              zIndex: 1
            }}
          />

          {/* Conteúdo */}
          <Box
            sx={{
              position: 'relative',
              zIndex: 2,
              p: { xs: 3, md: 5 },
              pr: { xs: '40%', md: '45%' },
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              minHeight: { xs: 280, md: 'auto' }
            }}
          >
            <Typography
              variant='h4'
              sx={{
                fontWeight: 700,
                mb: 2,
                fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' }
              }}
            >
              Anuncie seus imóveis
              <br />
              na UMARKT
            </Typography>

            <Typography
              variant='body1'
              sx={{ color: 'text.secondary', mb: 1, fontSize: { xs: '0.875rem', md: '1rem' } }}
            >
              Mais visibilidade.{` `}
              <Box
                component='span'
                sx={{ fontWeight: 600, color: 'text.primary' }}
              >
                Leads diretos. Sem comissão.
              </Box>
            </Typography>

            <Typography
              variant='body2'
              sx={{ color: 'text.secondary', mb: 3, fontSize: { xs: '0.8rem', md: '0.875rem' } }}
            >
              Nós ajudamos você a anunciar seus imóveis
              <br />
              de forma prática e eficaz.
            </Typography>

            <Button
              component={RouterLink}
              to='/dashboard/novo-imovel'
              variant='contained'
              size='large'
              startIcon={<AddHome />}
              sx={{
                bgcolor: 'primary.main',
                px: { xs: 2, md: 3 },
                py: { xs: 1, md: 1.5 },
                fontWeight: 600,
                borderRadius: 3,
                mb: 3,
                width: 'fit-content',
                fontSize: { xs: '0.8rem', md: '1rem' },
                '&:hover': { bgcolor: 'primary.dark' }
              }}
            >
              Quero anunciar agora
            </Button>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box
                component='img'
                src='/logo_aux.png'
                alt='Logo'
                sx={{ width: 22, height: 22 }}
              />
              <Typography variant='body1' sx={{ fontWeight: 700 }}>
                umarkt
              </Typography>
            </Box>
          </Box>

          {/* Imagem (desktop) */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: '55%',
              height: '100%',
              display: { xs: 'none', md: 'block' }
            }}
          >
            <Box
              component='img'
              src={bannerProfissionais}
              alt='Banner para corretores e imobiliárias'
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'left top'
              }}
            />
          </Box>
        </Paper>

        {/* Header */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant='h3'
            sx={{ fontWeight: 700, color: 'text.primary', mb: 2 }}
          >
            Para Imobiliárias e Corretores
          </Typography>
          <Typography
            variant='h6'
            sx={{
              color: 'text.secondary',
              maxWidth: '900px',
              mx: 'auto',
              lineHeight: 1.6
            }}
          >
            A umarkt é um marketplace projetado para oferecer visibilidade,
            organização e inteligência para profissionais do mercado
            imobiliário.
          </Typography>
          <Typography
            variant='body1'
            sx={{
              color: 'text.secondary',
              maxWidth: '900px',
              mx: 'auto',
              mt: 2,
              lineHeight: 1.6
            }}
          >
            Aqui, corretores e imobiliárias encontram uma plataforma moderna,
            simples e eficiente para divulgar seus imóveis e receber leads
            qualificados diretamente.
          </Typography>
          <Typography
            variant='body1'
            sx={{
              color: 'text.secondary',
              maxWidth: '900px',
              mx: 'auto',
              mt: 1,
              lineHeight: 1.6,
              fontWeight: 500
            }}
          >
            Nosso objetivo é facilitar sua rotina e ampliar sua presença digital
            — com tecnologia acessível, filtros inteligentes e ranking justo
            para todos.
          </Typography>
        </Box>

        {/* Por que anunciar */}
        <Box sx={{ mb: 6 }}>
          <Typography
            variant='h4'
            sx={{
              fontWeight: 700,
              mb: 4,
              color: 'text.primary',
              textAlign: 'center'
            }}
          >
            Por Que Anunciar na umarkt?
          </Typography>
          <Grid container spacing={3}>
            {benefits.map((benefit, index) => (
              <Grid size={{ xs: 12, md: 6 }} key={index}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    height: '100%',
                    borderRadius: 3,
                    border: '1px solid',
                    borderColor: 'grey.200',
                    transition: 'all 0.3s',
                    '&:hover': {
                      borderColor: 'primary.main',
                      transform: 'translateY(-4px)',
                      boxShadow: '0px 8px 24px rgba(255, 127, 39, 0.15)'
                    }
                  }}
                >
                  <Box
                    sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}
                  >
                    <Box
                      sx={{
                        width: 50,
                        height: 50,
                        borderRadius: '50%',
                        bgcolor: 'primary.light',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        color: 'primary.main'
                      }}
                    >
                      {React.cloneElement(benefit.icon, {
                        sx: { fontSize: '1.5rem' }
                      })}
                    </Box>
                    <Box>
                      <Typography
                        variant='h6'
                        sx={{
                          fontWeight: 600,
                          mb: 1,
                          color: 'text.primary',
                          fontSize: '1rem'
                        }}
                      >
                        {benefit.title}
                      </Typography>
                      <Typography
                        variant='body2'
                        sx={{ color: 'text.secondary', lineHeight: 1.7 }}
                      >
                        {benefit.description}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Divider sx={{ my: 6 }} />

        {/* Benefícios Exclusivos */}
        <Box sx={{ mb: 6 }}>
          <Typography
            variant='h4'
            sx={{
              fontWeight: 700,
              mb: 4,
              color: 'text.primary',
              textAlign: 'center'
            }}
          >
            Benefícios Exclusivos para Imobiliárias
          </Typography>
          <Paper elevation={0} sx={{ p: 4, bgcolor: 'white', borderRadius: 3 }}>
            <Grid container spacing={2}>
              {exclusiveFeatures.map((feature, index) => (
                <Grid
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 4
                  }}
                  key={index}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    {React.cloneElement(feature.icon, {
                      sx: { color: 'success.main', fontSize: '1.3rem' }
                    })}
                    <Typography
                      variant='body2'
                      sx={{ color: 'text.secondary' }}
                    >
                      {feature.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Box>

        <Divider sx={{ my: 6 }} />

        {/* Como Funciona */}
        <Box sx={{ mb: 6 }}>
          <Typography
            variant='h4'
            sx={{
              fontWeight: 700,
              mb: 4,
              color: 'text.primary',
              textAlign: 'center'
            }}
          >
            Como Funciona Para Profissionais
          </Typography>
          <Paper elevation={0} sx={{ p: 4, bgcolor: 'white', borderRadius: 3 }}>
            <Grid container spacing={4}>
              {steps.map((step, index) => (
                <Grid size={{ xs: 12 }} key={index}>
                  <Box
                    sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}
                  >
                    <Chip
                      label={step.number}
                      sx={{
                        bgcolor: 'primary.main',
                        color: 'white',
                        fontWeight: 700,
                        fontSize: '1.2rem',
                        height: 50,
                        width: 50,
                        borderRadius: '50%'
                      }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant='h5'
                        sx={{ fontWeight: 600, mb: 1, color: 'text.primary' }}
                      >
                        {step.title}
                      </Typography>
                      <Typography
                        variant='body1'
                        sx={{ color: 'text.secondary', lineHeight: 1.7 }}
                      >
                        {step.description}
                      </Typography>
                    </Box>
                  </Box>
                  {index < steps.length - 1 && <Divider sx={{ mt: 3 }} />}
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Box>

        <Divider sx={{ my: 6 }} />

        {/* Destaques */}
        <Box sx={{ mb: 6 }}>
          <Typography
            variant='h4'
            sx={{
              fontWeight: 700,
              mb: 3,
              color: 'text.primary',
              textAlign: 'center'
            }}
          >
            Destaques (Opcional)
          </Typography>
          <Paper
            elevation={0}
            sx={{
              p: 4,
              bgcolor: 'primary.main',
              color: 'white',
              borderRadius: 3
            }}
          >
            <Typography variant='body1' sx={{ mb: 3, lineHeight: 1.8 }}>
              Corretores e imobiliárias podem impulsionar anúncios para ampliar
              visibilidade. O sistema funciona por multiplicadores inteligentes:
            </Typography>
            <Grid container spacing={2}>
              {boostLevels.map((boost, index) => (
                <Grid
                  size={{
                    xs: 12,
                    sm: 4
                  }}
                  key={index}
                >
                  <Box
                    sx={{
                      p: 2,
                      bgcolor: 'rgba(255,255,255,0.1)',
                      borderRadius: 2,
                      textAlign: 'center'
                    }}
                  >
                    <Typography variant='h6' sx={{ fontWeight: 600, mb: 1 }}>
                      {boost.level}
                    </Typography>
                    <Typography variant='body2' sx={{ opacity: 0.9 }}>
                      {boost.description}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
            <Typography variant='body2' sx={{ mt: 3, opacity: 0.9 }}>
              Sem prejudicar a experiência dos usuários e sem distorcer o
              resultado.
            </Typography>
          </Paper>
        </Box>

        <Divider sx={{ my: 6 }} />

        {/* Integração com CRMs */}
        <Box sx={{ mb: 6 }}>
          <Typography
            variant='h4'
            sx={{
              fontWeight: 700,
              mb: 3,
              color: 'text.primary',
              textAlign: 'center'
            }}
          >
            Integração com CRMs (Futuro)
          </Typography>
          <Paper elevation={0} sx={{ p: 4, bgcolor: 'white', borderRadius: 3 }}>
            <Typography
              variant='body1'
              sx={{ mb: 3, color: 'text.secondary', lineHeight: 1.8 }}
            >
              Estamos estruturando integrações via:
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
              {integrationFormats.map((format, index) => (
                <Chip
                  key={index}
                  label={format}
                  sx={{
                    bgcolor: 'grey.100',
                    fontWeight: 600,
                    fontSize: '1rem',
                    py: 2.5
                  }}
                />
              ))}
            </Box>
            <Typography
              variant='body1'
              sx={{ color: 'text.secondary', lineHeight: 1.8 }}
            >
              Para imobiliárias que utilizam CRM, em breve será possível
              sincronizar automaticamente seu estoque com o marketplace.
            </Typography>
          </Paper>
        </Box>

        <Divider sx={{ my: 6 }} />

        {/* CTA - Seja Nosso Parceiro */}
        <Paper
          elevation={0}
          sx={{
            p: 5,
            textAlign: 'center',
            bgcolor: 'secondary.main',
            color: 'white',
            borderRadius: 3
          }}
        >
          <Typography variant='h4' sx={{ fontWeight: 700, mb: 2 }}>
            Seja Nosso Parceiro
          </Typography>
          <Typography
            variant='body1'
            sx={{ mb: 4, opacity: 0.9, maxWidth: '700px', mx: 'auto' }}
          >
            Quer anunciar seus imóveis, integrar seu CRM ou conversar sobre
            oportunidade de parceria?
          </Typography>
          <Button
            component={RouterLink}
            to='/registro'
            variant='contained'
            size='large'
            startIcon={<BusinessCenter />}
            sx={{
              bgcolor: 'primary.main',
              color: 'white',
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              fontWeight: 600,
              '&:hover': {
                bgcolor: 'primary.dark'
              }
            }}
          >
            Criar Conta Profissional
          </Button>
        </Paper>
      </Container>
    </Box>
  )
}

export default ForProfessionals
